import React, { useEffect, useState } from 'react'
import './index.less'

import NavigationBar from '@/components/NavigationBar'
import { request } from "@/utils";
import { useLocation } from "react-router-dom";
import Config from '@/config/config';




export default function VisitReport() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [data, setData] = useState({})

    const fetchData = async () => {
        try {
            const response = await request.get('visit/detail?id=' + searchParams.get('id'));
            setData(response.data || {})
            console.log(response.data)
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className='visitReport'>
            <NavigationBar showNavRight={false} showNavTabs={false}></NavigationBar>
            <div className="visitReport-container">
                <img src={Config.imgPrefix+data?.visit_pic} alt="" />
                <div className="visitReport-title">
                    {data?.visit_title}
                </div>
                <div>
                    {data?.visit_intro}
                </div>
                <div className="visitReport-content" dangerouslySetInnerHTML={{ __html: data?.visit_content }}>

                </div>
            </div>
        </div>
    )
}